/**
 * Fusionne les notifications locales Entrea et celles de la plateforme (/api/v1/messaging).
 */
export async function loadMergedNotifications(notificationsAPI, messagingPlatformAPI) {
  const [localRes, messagingRes] = await Promise.allSettled([
    notificationsAPI.getAll(),
    messagingPlatformAPI.listNotifications({ limit: 200 }),
  ]);
  const localData = localRes.status === 'fulfilled' ? localRes.value?.data : null;
  const messagingData = messagingRes.status === 'fulfilled' ? messagingRes.value?.data : null;
  const localItems = Array.isArray(localData) ? localData : localData?.notifications || [];
  const msgItems = messagingData?.notifications || [];

  const normalizedMsg = msgItems.map((n) => ({
    ...n,
    id: n.id,
    title: n.title || n.type || 'Notification',
    message: n.message || n.body || '',
    read: Boolean(n.read || n.read_at),
    created_at: n.created_at || n.date,
    source: 'messaging',
  }));
  const normalizedLocal = localItems.map((n) => ({
    ...n,
    read: Boolean(n.read || n.read_at),
    source: 'entrea',
  }));
  return [...normalizedMsg, ...normalizedLocal].sort(
    (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
  );
}

export async function markNotificationReadMerged(n, notificationsAPI, messagingPlatformAPI) {
  if (n?.source === 'messaging' && n?.id) {
    return messagingPlatformAPI.markNotificationRead(n.id);
  }
  if (n?.id) {
    return notificationsAPI.markAsRead(n.id);
  }
  return Promise.resolve();
}
